import React from 'react';

import { useChatContext } from '~/components/AiChat/hooks/useChat';
import { useClaim } from '~/components/ClaimContainer';
import Chip from '~/components/core/Atomic/Chip/Chip';
import Tooltip from '~/components/core/Atomic/Tooltip';

export const EmbeddedChatHeaderBadge: React.FC = () => {
  const { claim } = useClaim({ claimRequired: true });
  const { chat } = useChatContext();

  const label = chat?.chat_title || `Claim ${claim.claim_id_display}`;

  return (
    <Tooltip title={label}>
      <Chip label={label} className="max-w-[800px] truncate bg-azure-200 text-lg font-medium text-blue-800" />
    </Tooltip>
  );
};
